module.exports = __webpack_public_path__ + "assets/wait-yellow.0dd0a098.svg";